import PropTypes from 'prop-types';

/**
 * Search input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 */
const SearchInput = ({ id, placeholder, value, onChange, onKeyDown }) => {
    return (
        <>
            <input
                type="search"
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
        </>
    );
};

SearchInput.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
};

export default SearchInput;